/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PageLayout from 'src/common/components/PageLayout';
import SearchByNumber from '../ConsultResolution/Forms/SearchByNumber';
import { userTypeTabs } from './utils/list_data';
import AntTabs from 'src/common/components/AntTabs';
import { useLocation, useHistory } from 'react-router-dom';

const ConsultResolution = () => {
	const location = useLocation();
	const history = useHistory();
	const getTabFromQuery = () => {
		const params = new URLSearchParams(location.search);
		return params.get('tab') ? Number(params.get('tab')) : 1;
	};
	const [tabValue, setTabValue] = useState(getTabFromQuery());
	const handleChangeTab = (newValue) => {
		setTabValue(newValue);
		history.push(`?tab=${newValue}`);
	};
	useEffect(() => {
		const currentTab = getTabFromQuery();
		if (currentTab !== tabValue) {
			setTabValue(currentTab);
		}
	}, [location.search]);

	return (
		<>
			<PageLayout title="Consulta de Resoluciones/Recomendaciones">
				<AntTabs
					value={tabValue}
					options={userTypeTabs}
					onChange={handleChangeTab}
				/>
				<SearchByNumber tab={tabValue} />
			</PageLayout>
		</>
	);
};

export default ConsultResolution;
